// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface ProgramEnrollmentsV2 {
  id: string;
  userId: number;
  programId: string;
  jsonFormat: any;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface ProgramEnrollmentsV2Connection {
  elements: Array<ProgramEnrollmentsV2> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface ProgramEnrollmentsV2AvailableInvitedProgramsForProductQuery {
  ProgramEnrollmentsV2: {
    availableInvitedProgramsForProduct: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2AvailableInvitedProgramsForProductQueryVariables {
  userId: string;
  productId: string;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2AvailableProgramsForUserAndCourseIdQuery {
  ProgramEnrollmentsV2: {
    availableProgramsForUserAndCourseId: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2AvailableProgramsForUserAndCourseIdQueryVariables {
  userId: string;
  courseId: string;
  thirdPartyOrganizationId?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2AvailableProgramsForUserAndS12nIdQuery {
  ProgramEnrollmentsV2: {
    availableProgramsForUserAndS12nId: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2AvailableProgramsForUserAndS12nIdQueryVariables {
  userId: string;
  s12nId: string;
  thirdPartyOrganizationId?: string | null;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface ProgramEnrollmentsV2AddS12nCompletionRecordMutation {
  ProgramEnrollmentsV2: {
    addS12nCompletionRecord: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2AddS12nCompletionRecordMutationVariables {
  userId: string;
  s12nId: string;
  completionTimestamp: string;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2BackfillCourseEnrollmentMutation {
  ProgramEnrollmentsV2: {
    backfillCourseEnrollment: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2BackfillCourseEnrollmentMutationVariables {
  userId: string;
  courseId: string;
  programId: string;
  cartId: string;
  cartItemId: string;
  backfillTimestamp: string;
  latestActivityTimestampOption?: string | null;
  completionTimestampOption?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2BackfillS12nEnrollmentMutation {
  ProgramEnrollmentsV2: {
    backfillS12nEnrollment: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2BackfillS12nEnrollmentMutationVariables {
  userId: string;
  s12nId: string;
  programId: string;
  backfillTimestamp: string;
  latestActivityTimestampOption?: string | null;
  completionTimestampOption?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2ChangeProductStateMutation {
  ProgramEnrollmentsV2: {
    changeProductState: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2ChangeProductStateMutationVariables {
  programId: string;
  productId: string;
  actionType: string;
  userId?: string | null;
  collectionId?: string | null;
  programEnrollmentActionReason?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2DeleteAllSelectedProductsMutation {
  ProgramEnrollmentsV2: {
    deleteAllSelectedProducts: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2DeleteAllSelectedProductsMutationVariables {
  programId: string;
  userId: string;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2DowngradeCourseEnrollmentMutation {
  ProgramEnrollmentsV2: {
    downgradeCourseEnrollment: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2DowngradeCourseEnrollmentMutationVariables {
  userId: string;
  courseId: string;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2DowngradeEnrollmentsByUserProgramContractMutation {
  ProgramEnrollmentsV2: {
    downgradeEnrollmentsByUserProgramContract: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2DowngradeEnrollmentsByUserProgramContractMutationVariables {
  contractId: string;
  programId: string;
  userId: string;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2DowngradeS12nEnrollmentMutation {
  ProgramEnrollmentsV2: {
    downgradeS12nEnrollment: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2DowngradeS12nEnrollmentMutationVariables {
  s12nId: string;
  userId: string;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2EnrollInCourseMutation {
  ProgramEnrollmentsV2: {
    enrollInCourse: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2EnrollInCourseMutationVariables {
  programId: string;
  courseId: string;
  userId?: string | null;
  collectionId?: string | null;
  isAutoEnroll?: string | null;
  programEnrollmentActionReason?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2EnrollInS12nMutation {
  ProgramEnrollmentsV2: {
    enrollInS12n: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2EnrollInS12nMutationVariables {
  programId: string;
  s12nId: string;
  userId?: string | null;
  collectionId?: string | null;
  isAutoEnroll?: string | null;
  programEnrollmentActionReason?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2GetNextEnrollmentContractIdMutation {
  ProgramEnrollmentsV2: {
    getNextEnrollmentContractId: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2GetNextEnrollmentContractIdMutationVariables {
  programId: string;
  userId: string;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2MigrateEnrollmentToNewRosterMutation {
  ProgramEnrollmentsV2: {
    migrateEnrollmentToNewRoster: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2MigrateEnrollmentToNewRosterMutationVariables {
  userProductStateRecordId: string;
  destinationRosterId: string;
  migrationId?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2MigrateWishlistedProductsToNewRosterMutation {
  ProgramEnrollmentsV2: {
    migrateWishlistedProductsToNewRoster: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2MigrateWishlistedProductsToNewRosterMutationVariables {
  userId: string;
  sourceRosterId: string;
  destinationRosterId: string;
  allowDeletedSourceRoster?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2ProcessDowngradeMutation {
  ProgramEnrollmentsV2: {
    processDowngrade: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2ProcessDowngradeMutationVariables {
  userId: string;
  courseId: string;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2ProcessEnrollmentTriggerEventMutation {
  ProgramEnrollmentsV2: {
    processEnrollmentTriggerEvent: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2ProcessEnrollmentTriggerEventMutationVariables {
  userId: string;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2ProcessRefundMutation {
  ProgramEnrollmentsV2: {
    processRefund: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2ProcessRefundMutationVariables {
  userId: string;
  courseId: string;
  programEnrollmentActionReason?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2RefundOrDowngradeProductEnrollmentsMutation {
  ProgramEnrollmentsV2: {
    refundOrDowngradeProductEnrollments: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2RefundOrDowngradeProductEnrollmentsMutationVariables {
  userId: string;
  programId: string;
  forceRefund?: string | null;
  skipAlreadyProcessed?: string | null;
  forceDowngrade?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2SelectCourseMutation {
  ProgramEnrollmentsV2: {
    selectCourse: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2SelectCourseMutationVariables {
  programId: string;
  courseId: string;
  userId?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2SelectS12nMutation {
  ProgramEnrollmentsV2: {
    selectS12n: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2SelectS12nMutationVariables {
  programId: string;
  s12nId: string;
  userId?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2UnenrollFromCourseMutation {
  ProgramEnrollmentsV2: {
    unenrollFromCourse: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2UnenrollFromCourseMutationVariables {
  courseId: string;
  userId?: string | null;
  isAutoUnenroll?: string | null;
  forceRefund?: string | null;
  programEnrollmentActionReason?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2UnenrollFromS12nMutation {
  ProgramEnrollmentsV2: {
    unenrollFromS12n: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2UnenrollFromS12nMutationVariables {
  s12nId: string;
  userId?: string | null;
  programEnrollmentActionReason?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2UnselectCourseMutation {
  ProgramEnrollmentsV2: {
    unselectCourse: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2UnselectCourseMutationVariables {
  programId: string;
  courseId: string;
  userId?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2UnselectS12nMutation {
  ProgramEnrollmentsV2: {
    unselectS12n: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2UnselectS12nMutationVariables {
  programId: string;
  s12nId: string;
  userId?: string | null;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2UpdateCourseLatestActivityRecordMutation {
  ProgramEnrollmentsV2: {
    updateCourseLatestActivityRecord: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2UpdateCourseLatestActivityRecordMutationVariables {
  userId: string;
  courseId: string;
  latestActivityTimestamp: string;
  isCompleted: string;
  includes?: string | null;
}

export interface ProgramEnrollmentsV2UpgradeS12nEnrollmentMutation {
  ProgramEnrollmentsV2: {
    upgradeS12nEnrollment: ProgramEnrollmentsV2Connection | null;
  } | null;
}

export interface ProgramEnrollmentsV2UpgradeS12nEnrollmentMutationVariables {
  s12nId: string;
  userId?: string | null;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
      ? PartialConstruction<T[TKey]>
      : T[TKey];
};

export class ProgramEnrollmentsV2NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'programEnrollments.v2' as const;

  declare id: string;

  declare userId: number;

  declare programId: string;

  declare jsonFormat: any;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<ProgramEnrollmentsV2>) {
    super(params);
  }
}
